/* Style Mobo — Shared utilities */
(function () {
  if (window.SMUtils) return;

  const SMUtils = {
    formatMoney(cents) {
      return '₹' + Math.round(cents / 100);
    },

    escapeHtml(str) {
      const div = document.createElement('div');
      div.textContent = String(str);
      return div.innerHTML;
    },

    debounce(fn, wait = 200) {
      let t;
      return (...args) => { clearTimeout(t); t = setTimeout(() => fn(...args), wait); };
    },

    trapFocus(element) {
      const focusable = element.querySelectorAll(
        'a[href], button:not([disabled]), input:not([disabled]), select, textarea, [tabindex]:not([tabindex="-1"])'
      );
      if (!focusable.length) return;
      const first = focusable[0];
      const last = focusable[focusable.length - 1];

      function handleTab(e) {
        if (e.key !== 'Tab') return;
        if (e.shiftKey) {
          if (document.activeElement === first) { e.preventDefault(); last.focus(); }
        } else {
          if (document.activeElement === last) { e.preventDefault(); first.focus(); }
        }
      }
      element.addEventListener('keydown', handleTab);
      first.focus();
      return () => element.removeEventListener('keydown', handleTab);
    }
  };

  /* ── Toast notification ── */
  const SMToast = (() => {
    let container;

    function getContainer() {
      if (!container) {
        container = document.createElement('div');
        container.className = 'sm-toast-container';
        document.body.appendChild(container);
      }
      return container;
    }

    function show(message, duration = 2800) {
      const toast = document.createElement('div');
      toast.className = 'sm-toast';
      toast.textContent = message;
      getContainer().appendChild(toast);

      requestAnimationFrame(() => {
        requestAnimationFrame(() => toast.classList.add('is-visible'));
      });

      setTimeout(() => {
        toast.classList.remove('is-visible');
        toast.addEventListener('transitionend', () => toast.remove(), { once: true });
      }, duration);
    }

    return { show };
  })();

  /* ── Cart coupon apply/remove ──
     Shopify's AJAX Cart API accepts a "discount" field on /cart/update.js —
     applies (or clears, if blank) a discount code against the live cart.
     Applying a new code always REPLACES whatever code was active before —
     that's a Shopify platform limit (one discount code at a time on
     standard plans), not something this theme can lift — so a shopper can
     still pick whichever eligible coupon they want, just one at a time.

     /cart/update.js's own response can lag behind on total_price and
     discount_codes/cart_level_discount_applications right when a discount
     is applied or removed (the same quirk documented on _changeQty above,
     for /cart/change.js) — always follow up with a clean GET so the
     payment summary and coupon bar render from fully-resolved cart data. */
  const SMCartCoupon = {
    /* No "Applying…"/"Coupon applied" toasts — the caller (SMCoupons) shows
       a loading spinner on the tapped control for the duration instead, and
       the bar/list flipping to the applied state IS the success feedback.
       Toasts stay only for outcomes the UI wouldn't otherwise explain. */
    async apply(code) {
      if (!code) return null;
      try {
        await fetch('/cart/update.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ discount: code })
        });
        const cart = await fetch('/cart.js').then(r => r.json());
        document.dispatchEvent(new CustomEvent('sm:cart:updated', { detail: cart }));
        const entry = (cart.discount_codes || []).find(
          d => (d.code || '').trim().toUpperCase() === code.trim().toUpperCase()
        );
        if (!entry || !entry.applicable) {
          /* Shopify only says applicable:true/false, no reason — the two
             common causes are the code's own minimum in Admin not being met
             yet, or it can't combine with a discount already on the cart
             (e.g. an Automatic discount). Either way there's nothing more
             specific to tell the shopper here. */
          if (window.SMToast) window.SMToast.show("That coupon isn't valid for this cart right now.");
        }
        return cart;
      } catch {
        if (window.SMToast) window.SMToast.show('Something went wrong applying the coupon.');
        return null;
      }
    },

    /* pass the code/title that was showing as applied so we can tell a real
       removal apart from an Automatic discount that just reapplies itself —
       Shopify's discount:'' field only ever clears a discount CODE. */
    async remove(expectedCode) {
      try {
        await fetch('/cart/update.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ discount: '' })
        });
        const cart = await fetch('/cart.js').then(r => r.json());
        document.dispatchEvent(new CustomEvent('sm:cart:updated', { detail: cart }));
        const stillApplied = expectedCode && (cart.cart_level_discount_applications || []).some(
          a => (a.title || '').trim().toUpperCase() === expectedCode.trim().toUpperCase()
        );
        if (stillApplied && window.SMToast) {
          window.SMToast.show("That discount applies automatically and can't be removed here.");
        }
        return cart;
      } catch {
        if (window.SMToast) window.SMToast.show('Something went wrong removing the coupon.');
        return null;
      }
    },
  };

  window.SMUtils = SMUtils;
  window.SMToast = SMToast;
  window.SMCartCoupon = SMCartCoupon;
})();
